import React, { Component,useRef } from 'react';
import CatService from '../../service/CatService';
import CatForm from './CatForm';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Menu } from 'primereact/menu';
import { Messages } from 'primereact/messages';
import { confirmPopup,ConfirmPopup } from 'primereact/confirmpopup'
import AppContext from '../../AppContext';
import { PermDialog } from '../common/PermGrid';
import { Checkbox } from 'primereact/checkbox';
import { ImportProgDialog } from './ImportProgDialog';
import { withTranslation } from 'react-i18next';
import { setCatIcon } from '../common/Icons';

export class CatGrid extends Component{
	static contextType = AppContext;

	constructor(props) {
        super(props);
		this.messages = React.createRef();
		this.menu = React.createRef();
		this.gridMessage = React.createRef();
		this.dataTable = React.createRef();
		this.state = {
            cats: [],
			selectedCats:[],
			parentCat:{id:0,name:'None',code:'None'},
			selectedCat:{id:0,name:'AAA',code:'AAA'},			
			formCat:null,
			displayForm:false,
			newCat:false,
			permDialog:false,
			displayAll:false,
			importProgVisible:false
        };	
		this.items=[
			{
			   label:this.props.t('Copy rows'),
			   command:()=>{this.copyToClipboard()}
			},
			{
			   label:this.props.t('Paste rows'),
			   command:()=>{this.pasteFromClipboard()}
			},
			{
			   label:this.props.t('Delete'),
			   command:(e)=>{this.deleteCat(e)}
			},
			{
				label:this.props.t('Export CSV'),
				command:()=>{this.exportCSV()}
			}
		 ];		
    }
	componentDidMount() {
		this._loadCats();
	}
	componentDidUpdate(prevProps, prevState) {
		if(prevProps.parentCat == null)
			return;		

		if (this.props.parentCat.id !== prevProps.parentCat.id) {
			this._loadCats();
		}
	}	
	_loadCats()
	{
		if(this.props.parentCat == null)
			return;		
		var ret;
		if(this.props.mode=='CHILD') 
			ret = CatService.getCats(this.props.parentCat.id,this.props.catType);
		else //mode == 'REL'
			ret = CatService.getChildRels(this.props.parentCat.id,this.props.catType);

		ret.then(r => { 
			if(this.props.mode=='REL' && !this.state.displayAll)
				r=r.filter((cat)=>{return (cat.relId)?true:false});
			this.setState({cats:r});	
		}).catch(err=>{
			this.showError(this.props.t("error."+err.message));
		});

		console.log('CONTEXT:'+this.context.appName);
	}
	openForm=()=>{
		this.setState({displayForm:true});
	}
	editCat=(cat)=>{
		this.setState({selectedCat:{...cat},newCat:false});
		this.setState({displayForm:true});
	}	
	editPerms=(cat)=>{
		this.setState({selectedCat:{...cat},newCat:false});
		this.setState({permDialog:true});
	}	
	openPage=(cat)=>{
		setCatIcon(cat);
		this.props.openPage(cat);
	}
	copyToClipboard=()=>{
		var _clip = [];
		for(var i=0; i<this.state.selectedCats.length; i++)
		{
			let str = JSON.stringify(this.state.selectedCats[i]);
			let _copy = JSON.parse(str);

			console.log(JSON.stringify(_copy));
			_clip.push(_copy);
		}
		this.context.clip = _clip;
		this.context.catType = this.props.catType;
	}
	pasteFromClipboard=()=>{
		if(this.context.clipType != this.props.catType)
		{
			this.showError('Not suitable for this table');//this.gridMessage.current.show({ severity: 'error', summary: 'error', detail: 'Not suitable for this table' });
			return;
		}
		for(var i=0; i<this.context.clip.length; i++)
			console.log('clip['+i+'] = '+JSON.stringify(this.context.clip[i]));
		var ret = CatService.insertCats(this.props.parentCat.id,this.context.clip,this.props.catType);
		ret.then(r => { this._loadCats() });
	}
	insertCat=()=>{
		console.log("insertCat called");
		this.setState({selectedCat:{code:'',name:'',parentGroup:false},newCat:true});
		this.openForm();
	}
	addRel=(cat)=>{
		console.log("addRel called");
		var ret = CatService.addCatRel(this.props.parentCat.id,cat.id);		
		ret.then((r)=>{
				let ind = this.findIndex(cat);
				let _cats = [...this.state.cats];
				let _cat={..._cats[ind]};
				_cat.relId=r.id;
				_cats[ind]=_cat;
				this.setState({cats:_cats});
			})
			.catch((error) => {
				console.log('CatGrid:error='+error);
				console.log(error.response.data.message);
				this.showError(error.response.data.message);
			});		
	}
	removeRel=(cat)=>{
		console.log("removeRel called");
		var ret = CatService.removeCatRel(cat.relId);		
		ret.then((r)=>{
				let ind = this.findIndex(cat);
				let _cats = [...this.state.cats];
				let _cat={..._cats[ind]};
				_cat.relId=null;
				_cats[ind]=_cat;
				this.setState({cats:_cats});
			})
			.catch((error) => {
				console.log('CatGrid:error='+error);
				console.log(error.response.data.message);
				this.showError(error.response.data.message);
			});		
	}

	deleteCat=(e)=>{
		//console.log("delete cat");
		if(this.state.selectedCats.length == 0)
			return;
			confirmPopup({
				target:e.currentTarget,
				message: this.props.t('Are you sure you want to delete selected items?'),
				header: this.props.t('Confirmation'),
				icon: 'pi pi-exclamation-triangle',
				accept: () => {
					let _cat = this.state.selectedCats[0]; //TODO
					var ret = CatService.deleteCat(_cat); 
					ret.then(()=>{
						let ind = this.findIndex(_cat);
						let _cats = this.state.cats;
						_cats.splice(ind,1);
						this.setState({cats:_cats,selectedCats:[]});
						this.props.catDeleted(_cat);
					}).catch((error)=>{
						console.log('CatGrid:deleteCat:error='+error);
						this.showError(error.message);
					});
				}
			});			
	}
	hideForm=()=>{
		this.setState({displayForm:false});
	}	
	findIndex=(cat)=>{
		for(var i=0; i<this.state.cats.length; i++)
		{
			if(this.state.cats[i].id == cat.id)
				return i;
		}
		return -1;
	}
	formOK=()=>{
		console.log("formOK:"+this.state.parentCat.id);
		if(this.state.newCat)
		{
			var ret = CatService.insertCat(this.props.parentCat.id,this.state.formCat,this.props.catType);		
			ret.then((r)=>{
				this.state.cats.push(r);
				this.setState({displayForm:false});
				console.log('CatGrid::formOK:props'+JSON.stringify(this.props));
				this.props.catAdded(r);
				})
				.catch((error) => {
					console.log('CatGrid:error='+error);
					console.log(error.response.data.message);
					this.showFormError(error.response.data.message);
				});		
		}
		else
		{
			var ret = CatService.updateCat(this.state.formCat);		
			ret.then((r)=>{
				//this.state.cats.push(r);
				this.setState({displayForm:false});
				let ind = this.findIndex(r);
				if(ind>=0)
				{
					let _cats = [...this.state.cats];
					_cats[ind] = r;
					this.setState({cats:_cats});
				}
				this.props.catChanged(r);
				})
				.catch((error) => {
					console.log('CatGrid:error='+error);
					console.log(error.response.data.message);
					this.showFormError(error.response.data.message);	
				});		
		}
	}	
	formClosed=()=>{
	}	
	renderFooter=(name)=>{
        return (
            <div>
                <Button label={this.props.t("Cancel")} icon="pi pi-times" onClick={this.hideForm} className="p-button-text" />
                <Button label={this.props.t("Ok")} icon="pi pi-check" onClick={this.formOK} autoFocus />
            </div>
        );
    }	
	formChanged=(cat)=>{
		this.setState({formCat:cat});
		console.log("formChanged:" + JSON.stringify(cat));
	}
	actionBodyTemplate=(rowData)=>{
        return (
            <React.Fragment>
				<div className='flex align-items-center gap-1'>
                <Button icon="pi pi-pencil" tooltip={this.props.t('Edit')} className="p-button-rounded p-button-sm p-button-text p-button-success mr-2" onClick={() => this.editCat(rowData)} />
                <Button 
					 icon="pi pi-key"  tooltip={this.props.t('Perms')}
					 className="p-button-sm mr-2" rounded small text
					 severity={rowData.permsDefined?'danger':'secondary'}
					 onClick={() => this.editPerms(rowData)} />
                <Button icon="pi pi-link"  tooltip={this.props.t('Open')} className="p-button-rounded p-button-sm p-button-text p-button-success mr-2" onClick={() => this.openPage(rowData)} />
				</div>
            </React.Fragment>
        );
	}	
	relBodyTemplate=(rowData)=>{
		if(rowData.relId)
			return <i className="pi pi-check"></i>
		return <></>
	}

	relButtonTemplate=(rowData)=>{
		if(rowData.relId)
			return <Button onClick={()=>this.removeRel(rowData)} icon="pi pi-minus" severity="danger" small rounded text></Button>
		return <Button onClick={()=>this.addRel(rowData)} icon="pi pi-plus" severity="success" small rounded text></Button>
	}
	renderForm=()=>{
		return <CatForm cat={this.state.selectedCat} onChange={this.formChanged}/>;
	}
	showFormError = (err) => {
		this.messages.current.show({ severity: 'error', summary: this.props.t('error'), detail: this.props.t("@error."+err)});
	}	
	showError = (err) => {
		this.gridMessages.current.show({ severity: 'error', summary: this.props.t('error'), detail: this.props.t("@error."+err)});
	}	
	displayAll=(e)=>{
		this.setState({displayAll:e.checked});
		this._loadCats();
	}
	exportCSV=()=>{
		this.dataTable.current.exportCSV(false);
	}
	onPermDialogClose=()=>{
		this.setState({permDialog:false});
	}
	openImportProgDialog=()=>{
		this.setState({importProgVisible:true});
	}
	onImportProgClose=()=>{
		this.setState({importProgVisible:false},()=>{
			this.props.refresh();
			this._loadCats();
		});
	}
	rowClass=(data)=>{
		if(this.props.mode=='CHILD')
			return '';
		if(data.relId)
			return '';
		return 'text-gray-200';
	}
	render=()=>{		
		console.log('CatGrid:render');
		var leftContents = (
			<React.Fragment>
				<Button label={this.props.t("New")} icon="pi pi-plus" className="p-button-success p-button-sm mr-2" onClick={this.insertCat} />
				{this.props.mode=='REL'?
				<div className="flex align-items-center ml-4">
        			<Checkbox inputId="displayAll" name="displayAll" checked={this.state.displayAll} onChange={this.displayAll}/>
        			<label htmlFor="displayAll" className="ml-2">{this.props.t('Display all outcome')}</label>
    			</div>:<></>}
				{
					this.props.parentCat.id==0?
					<Button label={this.props.t("Import Program")} icon="pi pi-plus" className="p-button-secondary p-button-sm mr-2 ml-2"
						onClick={this.openImportProgDialog}></Button>:<></>
				}
			</React.Fragment>
		);
		var rightContents = (
			<React.Fragment>
				<Menu model={this.items} popup ref={this.menu} />
				<Button label={this.props.t("Delete")} icon="pi pi-trash" className="p-button-secondary p-button-sm mr-2" onClick={this.deleteCat} />
				<Button className="p-button-secondary p-button-text p-button-sm" icon="pi pi-ellipsis-v" onClick={(event) => this.menu.current.toggle(event)}/>			
			</React.Fragment>
		);				
		var frm = this.renderForm();
		if(this.props.form != null)
			frm = this.props.form(this.state.selectedCat,this.formChanged);
		return (
			<div className="flex-1 flex-column">
			<Messages ref={this.gridMessage}></Messages>
			<Toolbar className="mt-2 mb-2" start={leftContents} end={rightContents} />
			<DataTable ref={this.dataTable} value={this.state.cats} size="small" stripedRows showGridlines selectionMode="multiple" className='h-20rem md:h-30rem'
				selection={this.state.selectedCats} onSelectionChange={e => this.setState({ selectedCats: e.value })} dataKey="id"
				rowClassName={this.rowClass} scrollable scrollHeight="flex">
				<Column selectionMode="multiple" headerStyle={{width: '3em'}} align="center"></Column>
				{this.props.mode=='REL'?<Column body={this.relBodyTemplate} header="REL" style={{width:'3em'}}></Column>:<></>}
				<Column field="id" header={this.props.t("Id")} style={{width:'10%'}} sortable></Column>
				<Column field="permsDefined" header={this.props.t("Perms")} style={{width:'10%'}} sortable></Column>
				<Column field="code" header={this.props.t("Code")} style={{width:'10%'}} sortable></Column>
				<Column field="name" header={this.props.t("Name")} style={{width:'50%'}} sortable></Column>
				<Column field="path" header={this.props.t("Path")} style={{width:'20%'}} sortable></Column>
				<Column body={this.actionBodyTemplate} style={{width:'10%'}}></Column>
				{this.props.mode=='REL'?<Column body={this.relButtonTemplate} header="" style={{width:'3em'}}></Column>:<></>}
			</DataTable>
			<Dialog header={this.props.t("entity."+this.props.catType)} visible={this.state.displayForm} style={{ width: '30vw' }} footer={this.renderFooter('displayBasic')} onHide={this.formClosed}>
				<Messages ref={this.messages}></Messages>
				<div className="p-2">{frm}</div>
			</Dialog>	
			{
				this.state.permDialog?
				<PermDialog visible={this.state.permDialog} objId={this.state.selectedCat.id} objType={'CAT'} 
					objName={this.state.selectedCat.name} onClose={this.onPermDialogClose} onHide={this.onPermDialogClose}></PermDialog>:<></>
			}
			{
				this.state.importProgVisible?
 				<ImportProgDialog visible={this.state.importProgVisible} onClose={this.onImportProgClose}></ImportProgDialog>:<></>			
			}
			<ConfirmPopup />
			</div>
		)
	}
	
}
export default withTranslation()(CatGrid);
